"use client";

import { useMemo } from "react";
import { parseInputs } from "@/lib/custom-indicators/indicator-source";
import CustomIndicatorInputsForm, {
  defaultValuesFromParsedInputs,
} from "../CustomIndicatorInputsForm";

export default function NavigatorInputsPreviewSection({
  code,
}: {
  code: string;
}) {
  const parsedInputs = useMemo(() => parseInputs(code), [code]);
  const defaultValues = useMemo(
    () => defaultValuesFromParsedInputs(parsedInputs),
    [parsedInputs],
  );

  return (
    <div className="min-h-0 flex-1 overflow-y-auto overscroll-contain p-3">
      <p className="mb-3 text-[10px] text-muted-foreground">
        Preview as end-user would see (default values)
      </p>
      <CustomIndicatorInputsForm
        parsedInputs={parsedInputs}
        values={defaultValues}
        onValueChange={() => {}}
        readOnly
      />
    </div>
  );
}
